import type { ISbStoryData } from '@storyblok/js'
import type { Page, ProductOffersSection } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import type { IProductCategory } from '@percent/cause-dashboard/app/productOffers/data/categories'
import type { GofundmeUserJourneysVariant } from '@percent/cause-dashboard/constants/gofundmeUserJourneys'
import { mapStoryblokProductOfferToProductOffer } from './mapStoryblokProductOfferToProductOffer'

function isProductOffersSection(blok: unknown): blok is ProductOffersSection {
  return Boolean(
    blok && typeof blok === 'object' && (blok as { component?: string }).component === 'product_offers_section'
  )
}

/**
 * Builds `IProductCategory[]` from a Storyblok `page` story for the marketplace.
 */
export function buildProductOffersCategoriesFromStory(
  story: ISbStoryData<Page>,
  gfmVariant: GofundmeUserJourneysVariant | null = null
): Array<{ id: number } & IProductCategory> {
  const body = story.content.body ?? []
  const sections = body.filter(isProductOffersSection)

  return sections.map((section, index) => {
    const offers = section.offers.flatMap(ref => {
      if (typeof ref === 'string') {
        return []
      }
      if (ref.content?.component !== 'product_offer') {
        return []
      }
      const mapped = mapStoryblokProductOfferToProductOffer(ref)
      if (!mapped || (mapped.experimentVariant && mapped.experimentVariant !== gfmVariant)) {
        return []
      }
      return [mapped]
    })

    return {
      id: index,
      name: section.title,
      description: section.description,
      tracking: section.tracking,
      offers
    }
  })
}
